import { PickerOption } from '../store/schema/CompositePickerInterfaces';
import CompositePickerStore from '../store/schema/CompositePickerStore';

/**
 * Used to find the filtered option in the list of original option (to maintain the navigation index for keyboard navigation)
 */
export default function getOriginalOptionFromFilteredOption(
    viewState: CompositePickerStore,
    filteredOption: PickerOption
): PickerOption | null {
    const { options } = viewState;

    for (let option of options) {
        for (let leafOption of option.leafOptions) {
            if (leafOption.id == filteredOption.id) {
                return leafOption;
            }
        }

        for (let parent of option.parentOptions) {
            if (parent?.children) {
                for (let child of parent.children) {
                    if (child.id == filteredOption.id) {
                        return child;
                    }
                }
            }
        }
    }

    return null;
}
